class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.closeTimer = null;

    if (this.dataset.openOnHover === 'true') this.initHoverBehaviour();
  }

  // Only take over on desktop widths with a real pointer. Touch devices keep the
  // default click-to-open behaviour, otherwise a tap would navigate away before
  // the submenu could ever be seen.
  get hoverEnabled() {
    return window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)').matches;
  }

  initHoverBehaviour() {
    this.addEventListener('mouseenter', () => {
      if (!this.hoverEnabled) return;
      clearTimeout(this.closeTimer);
      this.open();
    });

    // The pointer crosses the header's padding on its way down to the panel, so
    // hold the menu open briefly instead of closing the moment it leaves.
    this.addEventListener('mouseleave', () => {
      if (!this.hoverEnabled) return;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(), 200);
    });

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));
  }

  onSummaryClick(event) {
    if (!this.hoverEnabled) return;

    const link = event.target.closest('a[href]');
    if (!link || !this.summary.contains(link)) return;

    // Let modified clicks through so "open in new tab" still works; they toggle
    // the panel as well, which is harmless when the page does not change.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    // preventDefault cancels the <details> toggle and the navigation alike, so
    // follow the link ourselves.
    event.preventDefault();
    window.location.href = link.href;
  }

  open() {
    clearTimeout(this.closeTimer);
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
  }

  close() {
    clearTimeout(this.closeTimer);
    super.close();
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
